import { NextTrip } from "../types/NextTrip";

export const wallboardService = {
  nextTrip,
};

export function fetchResponseToJson(response: any) {

  function logout() {
    localStorage.removeItem("token");
  }
  return response.text().then((text: string) => {
    //const data = text && JSON.parse(text, parseWithDate);
    const data = text && JSON.parse(text);
    if (!response.ok) {
      if (response.status === 401) {
        // auto logout if 401 response returned from api
        logout();
      }

      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
}

function nextTrip(requestUrl: string): Promise<NextTrip> {
  const authHeader = new Headers();
  authHeader.append("Content-Type", "application/json");
  const requestOptions = {
    method: "GET",
    headers: authHeader,
  };
  return fetch(requestUrl, requestOptions).then(
    fetchResponseToJson
  );
}